import { FC } from 'react';
import {
	FirebaseAuthentication,
	SignInResult,
} from '@capacitor-firebase/authentication';
import {
	getAuth,
	GoogleAuthProvider,
	signInWithCredential,
	UserCredential,
} from 'firebase/auth';

import { GoogleButton } from '../../molecules/SocialButtons';

import {
	ISocialLoginResult,
	SocialLoginError,
	SocialLoginErrorCodeEnum,
	SocialProviderEnum,
	TPushEvent,
} from '.';

type LoginWithGoogleProps = {
	onSignIn: (callback: () => Promise<ISocialLoginResult>) => Promise<void>;
	pushAuthEvent?: TPushEvent;
	isRegistration?: boolean;
};

export const LoginWithGoogle: FC<LoginWithGoogleProps> = ({
	onSignIn,
	pushAuthEvent,
	isRegistration,
}) => {
	const signUpWithGoogle = async () => {
		try {
			const auth = getAuth();
			if (pushAuthEvent) {
				pushAuthEvent(
					isRegistration ? 'sign_up_attempt' : 'login_attempt',
					'google'
				);
			}
			const result: SignInResult =
				await FirebaseAuthentication.signInWithGoogle();
			if (!result.credential?.idToken) {
				throw new SocialLoginError(SocialLoginErrorCodeEnum.LOGIN_FAILED, {
					cause: 'Missing idToken',
				});
			}
			const credential = GoogleAuthProvider.credential(
				result.credential?.idToken
			);
			const signInResult: UserCredential = await signInWithCredential(
				auth,
				credential
			);
			if (!signInResult.user) {
				throw new SocialLoginError(SocialLoginErrorCodeEnum.LOGIN_FAILED, {
					cause: 'No user returned',
				});
			}
			if (pushAuthEvent) {
				pushAuthEvent(isRegistration ? 'sign_up' : 'login', 'google');
			}
			return { user: signInResult.user, providerId: SocialProviderEnum.GOOGLE };
		} catch (err: unknown) {
			if (
				err instanceof Error &&
				err.message.includes('No credentials available')
			) {
				throw new SocialLoginError(
					SocialLoginErrorCodeEnum.GOOGLE_ADD_ACCOUNT,
					{
						cause: err,
					}
				);
			}
			throw err;
		}
	};

	return <GoogleButton onClick={() => onSignIn(signUpWithGoogle)} />;
};
